import {RealtimeRepository} from "@api/repositories/reatime-repository/RealtimeRepository";
import {Observers, SignalRMethod} from "@api/repositories/reatime-repository/types";
import {Store} from "vuex";
import {parseJson} from "@common/TypesHelper";
import {SlidesUpdatedParam} from "@share/web-conferences/interfaces/signalr/SlidesUpdatedParam";
import {clearTimeoutForCurrentPresentation} from "@share/web-conferences/helpers/slides/CurrentPresentationAbsenceHandler";

export class ConvertingStatusObserver {
    private readonly observers: Observers;

    constructor(
        private readonly realtimeRepository: RealtimeRepository,
        private readonly schemaId: string,
        private readonly objectId: string,
        private readonly store: Store<any>,
        private readonly updater: (data: SlidesUpdatedParam) => void
    ) {
        this.observers = {
            [this.channelName]: {
                [SignalRMethod.webConferenceSlidesUpdated]: this.handler.bind(this)
            }
        }
    }

    private get channelName(): string {
        return `WebConference.${this.schemaId}.${this.objectId}.slides`;
    }

    private async handler(data: any): Promise<void> {
        const update = parseJson(data) as SlidesUpdatedParam;
        if (update && this.schemaId == update.schemaId && this.objectId == update.objectId) {
            this.updater(update);
            clearTimeoutForCurrentPresentation();
        }
    }

    async connect() {
        try {
            await this.realtimeRepository.attach(this.observers);
            return true;
        }
        catch (e) {
            this.store.dispatch('reportError', e);
        }
        return false;
    }

    async disconnect() {
        try {
            await this.realtimeRepository.detach(this.observers);
        }
        catch (e) {
            this.store.dispatch('reportError', e);
        }
    }
}
